import { clearAllHistory } from "./history";

function generateId(): string {
    if (typeof crypto !== "undefined" && typeof (crypto as any).randomUUID === "function") {
        return (crypto as any).randomUUID();
    }
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        const hex: string[] = [];
        for (let i = 0; i < 256; i++) hex[i] = (i + 0x100).toString(16).slice(1);
        const b = bytes;
        return (
            hex[b[0]] + hex[b[1]] + hex[b[2]] + hex[b[3]] + "-" +
            hex[b[4]] + hex[b[5]] + "-" +
            hex[b[6]] + hex[b[7]] + "-" +
            hex[b[8]] + hex[b[9]] + "-" +
            hex[b[10]] + hex[b[11]] + hex[b[12]] + hex[b[13]] + hex[b[14]] + hex[b[15]]
        );
    }
    return `r-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

const SESSION_KEY = "chatbot_session_id";
const AUTH_MARKER_KEY = "chatbot_auth_seen";

export function getOrCreateSessionId(key = SESSION_KEY): string {
    if (typeof window === "undefined") return `ssr-${generateId()}`;
    let existing: string | null = null;
    try { existing = window.localStorage.getItem(key); } catch { }
    if (existing) return existing;
    const id = generateId();
    try { window.localStorage.setItem(key, id); } catch { }
    return id;
}

// Issues a brand new session id, discarding the current one. Used when switching
// reports so the backend starts a fresh conversation instead of carrying the
// previous report's context forward under the same session.
export function resetSessionId(key = SESSION_KEY): string {
    const id = generateId();
    if (typeof window === "undefined") return id;
    try { window.localStorage.setItem(key, id); } catch { }
    return id;
}

export function clearChatbotSession(key = SESSION_KEY) {
    clearAllHistory();
    if (typeof window === "undefined") return;
    try {
        window.localStorage.removeItem(key);
        window.localStorage.removeItem(AUTH_MARKER_KEY);
    } catch { }
}

// Clears anything a previous sign-in left behind, on the first authenticated load
// after a logout. A clean logout already wipes the chat, so this only has work to do
// when the last session ended without one — a closed browser, a crash, or a logout
// driven from another device. The marker lives alongside the chat data and is removed
// by clearChatbotSession, so "marker missing while authenticated" means "new sign-in",
// while a reload or a second tab finds the marker present and leaves the chat alone.
export function syncChatbotAuthSession(authenticated: boolean) {
    if (typeof window === "undefined") return;

    let seen: string | null = null;
    try { seen = window.localStorage.getItem(AUTH_MARKER_KEY); } catch { }

    if (!authenticated) {
        if (seen) {
            try { window.localStorage.removeItem(AUTH_MARKER_KEY); } catch { }
        }
        return;
    }

    if (seen) return;

    clearChatbotSession();
    try { window.localStorage.setItem(AUTH_MARKER_KEY, "1"); } catch { }
}
